import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from 'react-bootstrap';

const FormInputLabel = ({ hide = false, children, ...rest }) => {
  if (hide || !children) {
    return <span />;
  }

  return (
    <div className="input-label" {...rest}>
      <FormLabel>
        {children}
        <span className="tilda">~</span>
      </FormLabel>
    </div>
  );
};

FormInputLabel.propTypes = {
  children: PropTypes.any,
  hide: PropTypes.bool,
};

export default FormInputLabel;
